import type { ActivityItem, NotificationsResponse } from '../types';
import { http } from '@/shared/api/httpClient';

export const activityApi = {
  project: (projectId: string, limit = 20) => http.get<ActivityItem[]>(`/projects/${projectId}/activity`, { params: { limit } }).then((r) => r.data),
  notifications: (limit = 10) => http.get<NotificationsResponse>('/notifications', { params: { limit } }).then((r) => r.data),
  /** Marks as read everything up to `until` (the newest notification shown); later ones stay unread. */
  seen: (until?: string) => http.post('/notifications/seen', null, { params: { until } }).then(() => undefined)
};
